import lectureService from '../services/lectures'
import { GET_ALL_LECTURES, LOAD_LECTURES } from '../actions/lecture'

import { notification } from 'antd'

const iso8601Duration = (duration) => {
  const durationRegex =
    /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/

  const matches = duration.match(durationRegex)

  // seconds
  if (!matches[7]) return `${matches[8]}`
  // min:seconds
  if (!matches[6]) return `${matches[7]}:${matches[8]}`
  // hours:mins:seconds
  if (!matches[5]) return `${matches[6]}:${matches[7]}:${matches[8]}`
}

const lectureReducer = (state = { data: [], loading: false }, action) => {
  switch (action.type) {
    case GET_ALL_LECTURES:
      return { data: action.data, loading: false }
    case LOAD_LECTURES:
      return { data: [], loading: true }
    default:
      return state
  }
}

export const getAllLectures = (courseId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_LECTURES })

      const response = await lectureService.getAllLectures(courseId)

      const youtubeLectures = response.filter(
        (lecture) => lecture.provider === 'youtube' && lecture.videoId
      )

      const videoIds = youtubeLectures
        .map((lecture) => lecture.videoId)
        .join(',')

      if (videoIds) {
        const data = await lectureService.getLecturesData(videoIds)

        const youtubeMap = {}
        data.items.forEach((item) => {
          youtubeMap[item.id] = item
        })

        response.forEach((lecture) => {
          if (lecture.provider !== 'youtube' || !lecture.videoId) return

          const yt = youtubeMap[lecture.videoId]
          if (!yt) return

          lecture.thumbnail = yt.snippet.thumbnails?.medium || null
          lecture.youtubeDescription = yt.snippet.description
          lecture.youtubeTitle = yt.snippet.title
          lecture.publishedAt = yt.snippet.publishedAt
            ?.slice(0, 10)
            .replaceAll('-', '/')

          lecture.duration = iso8601Duration(
            yt.contentDetails.duration
          )
        })
      }

      dispatch({ type: GET_ALL_LECTURES, data: response })
    } catch (error) {
      console.error(error)
      notification.error({
        message: "Couldn't load Lectures, check your connection"
      })
    }
  }
}

export default lectureReducer
